export default "__VITE_ASSET__ENR0yTEp__"